import React from 'react';
import PropTypes from 'prop-types';
import MaterialTable from 'material-table';
import moment from 'moment';
import 'moment/locale/th';

import { useTranslation } from 'react-i18next';

// ui
import Box from '@material-ui/core/Box';

// style
import tableIcons from '../../../components/table/MaterialTableIcon';

import RainColor from '../../rainfall/map/RinfallStatusColor';
import Contrast from '../../../utils/color/contrast';

// Utils
import exportCsv from '../../../utils/export/Csv';

function colorhelper(value, color) {
  let backgroundcol = '#FFFFFF';
  if (typeof color !== 'undefined') {
    backgroundcol = color.color;
  } else {
    backgroundcol = RainColor(value, 'rainfall24h').color.statusColor;
  }
  return backgroundcol;
}
export default function RainDetailList(props) {
  const { t } = useTranslation();
  const { datas, userIsLogin } = props;
  const isExport = (userIsLogin) ? { csv: true } : userIsLogin;

  return (
    <>
      <MaterialTable
        icons={tableIcons}
        columns={[
          {
            title: t('ชื่อสถานี'),
            title_export: t('ชื่อสถานี'),
            field: 'tele_station_name',
            width: 250,
            headerStyle: {
              left: 0,
              position: 'sticky',
              zIndex: 50,
              backgroundColor: '#CCCCCC',
            },
            cellStyle: {
              backgroundColor: '#fff',
              left: 0,
              position: 'sticky',
              wordWrap: 'break-word',
              whiteSpace: 'pre-wrap',
              textAlign: 'left',
            },
            render: (row) => (
              `${row.tele_station_oldcode} ${row.tele_station_name}`
            ),
          },
          {
            title: t('ที่ตั้ง'),
            title_export: t('จังหวัด'),
            field: 'geocode.province_name.th',
            type: 'string',
            width: 300,
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => `ต.${row.tumbon_name} อ.${row.amphoe_name} จ.${row.province_name}`,
          },
          {
            title: t('เวลา'),
            title_export: t('วันที่'),
            field: 'time',
            type: 'date',
            width: 80,
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => `${moment(row.time).format('HH:mm')} น.`,
          },
          {
            title: t('ฝนสะสม 24 ชม (มม.)'),
            title_export: t('ฝนสะสม (มม.)'),
            field: 'situation',
            type: 'string',
            width: 110,
            export: true,
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => {
              const status = colorhelper(row.rain_24, row.color24);
              return (
                <Box
                  borderRadius={3}
                  style={{
                    align: 'center',
                    textAlign: 'center',
                    margin: '0 auto',
                    width: '50px',
                    backgroundColor: status,
                    color: Contrast(status),
                  }}
                >
                  {row.rain_24}
                </Box>
              );
            },
          },
          {
            title: t('ฝนสะสม 1 ชม (มม.)'),
            title_export: t('ฝนสะสม (มม.)'),
            field: 'situation',
            type: 'string',
            width: 110,
            export: true,
            headerStyle: {
              backgroundColor: '#CCCCCC',
            },
            render: (row) => {
              const status = colorhelper(row.rain_1, row.color1);

              return (
                <Box
                  borderRadius={3}
                  style={{
                    align: 'center',
                    textAlign: 'center',
                    margin: '0 auto',
                    width: '50px',
                    backgroundColor: status,
                    color: Contrast(status),
                  }}
                >
                  {row.rain_1}
                </Box>
              );
            },
          },
          {
            title: t('รหัสสถานี'),
            title_export: t('รหัสสถานี'),
            field: 'station.tele_station_oldcode',
            type: 'string',
            hidden: true,
            export: true,
          },
        ]}
        data={datas}
        localization={{
          toolbar: {
            searchPlaceholder: t('ค้นหา'),
            exportTitle: t('ดาวน์โหลดข้อมูล ฝน'),
          },
          pagination: {
            labelRowsSelect: t('แถว'),
          },
          body: {
            emptyDataSourceMessage: t('ไม่มีข้อมูลตามเงื่อนไขที่เลือก'),
          },
        }}
        options={{
          tableLayout: 'fixed',
          pageSize: 5,
          sorting: true,
          search: false,
          rowStyle: {
            wordWrap: 'break-word',
          },
          toolbar: true,
          showTitle: false,
          exportButton: isExport,
          exportCsv,
        }}
        style={{ boxShadow: 'none' }}
      />
    </>
  );
}

RainDetailList.propTypes = {
  datas: PropTypes.instanceOf(Array).isRequired,
  userIsLogin: PropTypes.bool.isRequired,
};
